module.exports = __webpack_public_path__ + "static/scss-0c87fc9a81c2a492a24f6f1cec13621c.png";